import React, { useState, useEffect } from 'react';
import CrudTable from '../table/crudtable'
import { deviceService, licenseService } from '../../_services'
import { useTranslation } from "react-i18next";
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBug, faCopy } from '@fortawesome/free-solid-svg-icons'

function DeviceList() {
	const [licenses, setLicenses] = useState([])
    const {t} = useTranslation('common');

    useEffect(() => {
        licenseService.simpleList().then(licenses => {
            setLicenses(licenses)
        })
    }, [])

	const copyId = (id) => {
		navigator.clipboard.writeText(id)
		alert("Kopierat id!")
	}

    const formatDeviceId = (cell, row) => {
        return <div>
            <a href={'/device/' + row.id} title={cell}>
                { cell && cell.length > 11 &&
                    cell.substring(0, 4) + '...' + cell.substring(cell.length - 4, cell.length)
                }
                { (!cell || cell.length <= 11) &&
	                cell
	            }
            </a>
            &nbsp;
            <a onClick={e => copyId(cell)} style={{cursor: 'pointer'}}>
                <FontAwesomeIcon icon={faCopy} style={{fontSize: '12px'}}/>
            </a>
        </div>
	}

	const formatDate = (cell) => {
		return moment(cell).format('YYYY-MM-DD HH:mm')
	}

	const formatAppVersion = (cell) => {
		if (cell.includes('DEBUG')) {
			return <div>{cell.replace(' DEBUG', '')} <FontAwesomeIcon icon={faBug} style={{fontSize: '12px'}}/></div>
		}
		return cell
	}

	const formatSettings = (cell, row) => {
		return <div>
			{formatBoolean(row.deletePhotosAfterUpload)} / {formatBoolean(row.backupToLibrary)} / {formatBoolean(row.uploadOnWifiOnly)}
		</div>
	}

	const formatBoolean = (cell) => {
		return cell ? t('crudtable.yes') : t('crudtable.no')
	}

	const formatLicenses = (cell, row) => {
		var filteredLicenses = licenses.filter(license => row.licenses.includes(license.id)).sort(Intl.Collator().compare)
		if (row.currentLicenseCode) {
			var currentLicense = filteredLicenses.find(license => license.licenseCode == row.currentLicenseCode)
			if (currentLicense) {
				filteredLicenses = [currentLicense].concat(filteredLicenses.filter(license => license.licenseCode != row.currentLicenseCode))
			}
		}
		return filteredLicenses.map(license => license.name || license.licenseCode).join(', ')
	}

    const columns = [
        {
			dataField: 'deviceId',
			text: t('device.columns.deviceid'),
			formatter: formatDeviceId,
			sort: true
	    },
	    {
			dataField: 'username',
			text: t('device.columns.username'),
			sort: true
	    },
	    {
			dataField: 'osVersion',
			text: t('device.columns.osversion'),
			sort: true
	    },
	    {
			dataField: 'phoneModel',
			text: t('device.columns.phonemodel'),
			sort: true
	    },
	    {
			dataField: 'appVersion',
			text: t('device.columns.appversion'),
			formatter: formatAppVersion,
			sort: true
	    },
	    {
			dataField: 'settings',
			headerTitle: () => {
				return t('device.columns.deletephotosafterupload') + ' / ' +
					t('device.columns.backuptolibrary') + ' / ' +
					t('device.columns.uploadonwifionly')
			},
			text: t('device.columns.settings'),
			formatter: formatSettings,
			sort: true
	    },
	    {
			dataField: 'dateCreated',
			text: t('device.columns.datecreated'),
			formatter: formatDate,
			sort: true
	    },
	    {
			dataField: 'lastUpdated',
			text: t('device.columns.lastupdated'),
			formatter: formatDate,
			sort: true
	    },
	    {
			dataField: 'licenses',
			text: t('device.columns.licenses'),
			formatter: formatLicenses,
			filterValue: formatLicenses,
			sort: true
	    }
    ]

	return (
		<div>
			<h2>
				{t('device.label')}
            </h2>
            { licenses.length > 0 &&
	            <CrudTable
			        service={deviceService}
			        columns={columns}
			        remote={{"filter": false, "search": false, "pagination": false}}
					creatable={false}
					editable={false}
					deletable={true}
			        sort={{dataField: 'username', order: 'asc'}}
			        urlParams={true}
				/>
			}
		</div>
    )
}

export default DeviceList;